import { Keyword, List } from "@siteimprove/alfa-css";
import { Longhand } from "../longhand.js";
/**
 * @internal
 */
export const parse = Keyword.parse("repeat", "space", "round", "no-repeat");
const parseList = List.parseCommaSeparated(parse);
/**
 * @internal
 */
export const initialItem = Keyword.of("repeat");
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/background-repeat}
 * @internal
 */
export default Longhand.of(List.of([initialItem]), parseList, (value) => value);
//# sourceMappingURL=background-repeat-x.js.map